export default __webpack_public_path__ + "static/media/icons-mind-maps.3730a2b1.svg";